import cn from 'classnames';
import Label from '../Badge/Label/Label';
import styles from './toggleButtonGroup.module.scss';

export interface IProps {
  /** Badge content (number or text) */
  children: React.ReactNode,
  /** Additional CSS class names */
  className?: string,
}

const ToggleButtonGroupBadge = ({ children, className }: IProps): React.ReactElement => (
  <Label
    className={ cn(styles.badge, className) }
    backgroundColor="inherit"
    textColor="inherit"
    fontSize={ 10 }
    isBold
  >
    { children }
  </Label>
);

export default ToggleButtonGroupBadge;
